import { CashOperation, CashOperationsSearchRequest } from "../../../models/CashOperation";
import { PagedResult, Result } from "../../../models/Result";
import { httpService } from "../../HttpService";

/**
 * Cash-operations (cash-in deposits) for the Merchant Portal — talks to the Payment Adapter
 * (TNPDEVAPPS-1755). Uses the "pay" base URL, falling back to the default gateway.
 */
class CashOperationsApiService {
    baseApiUrl = process.env.REACT_APP_PAY_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL;
    path: string = "api/cash";

    getAllPaged = async (searchRequest: CashOperationsSearchRequest): Promise<PagedResult<CashOperation[]>> =>
        await httpService.getPage<CashOperation[]>(`${this.path}/intents/search`, searchRequest, { baseURL: this.baseApiUrl });

    retry = async (id: string): Promise<Result<CashOperation>> =>
        await httpService.post<CashOperation>(`${this.path}/intent/${id}/retry`, {}, { baseURL: this.baseApiUrl });
}

const cashOperationsApiService = new CashOperationsApiService();

export { cashOperationsApiService };
